var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4BAD50;}\n\t.st1{fill:#FDFEFD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000.7,0c551.1,0.3,999.4,449.1,999.3,1000.2c-0.1,551.7-450,1000.8-1001.7,999.8 C446.5,1999-1,1549.3,0,996.8C1,447.3,450.4-0.3,1000.7,0z M1585.8,715.9c-0.5-13.3-8-22.8-17-31.8 c-43.3-43.2-86.5-86.5-129.8-129.7c-29.7-29.6-45.3-29.7-74.9,0c-172,172.1-344.2,344.1-515.8,516.7c-11.5,11.6-17.3,11.5-28.6-0.1 C756.8,1007,693,943.7,629.4,880.3c-22.9-22.8-40.7-22.7-63.6,0.1c-43.8,43.6-87.5,87.4-131.2,131.1c-28.2,28.3-28.2,43.5,0.2,72 c120.3,120.8,240.6,241.6,361,362.3c30.1,30.2,44.6,30.3,74.7,0.2c78.3-78.1,156.5-156.4,234.8-234.5 c154.2-154.1,308.4-308.1,462.7-462.1C1577.4,740,1585.9,730.3,1585.8,715.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1585.8,716c0.1,14.3-8.4,24-17.8,33.4c-154.3,154-308.5,308.1-462.7,462.1 c-78.3,78.2-156.5,156.4-234.8,234.5c-30.1,30.1-44.6,30-74.7-0.2c-120.3-120.8-240.7-241.5-361-362.3c-28.4-28.5-28.5-43.8-0.2-72 c43.7-43.7,87.3-87.5,131.2-131.1c22.9-22.8,40.7-22.9,63.6-0.1c63.6,63.4,127.3,126.7,190.2,190.8c11.3,11.5,17.1,11.7,28.6,0.1 c171.6-172.5,343.8-344.5,515.8-516.7c29.6-29.7,45.2-29.6,74.9,0c43.3,43.2,86.4,86.6,129.8,129.7 C1577.8,693.1,1585.3,702.6,1585.8,716z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.2627b9b9460fde97ed420d95c2a9deed.svg";
export { ForwardRef as ReactComponent };